"use strict";

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decryptStream = exports.encryptStream = void 0;

var buffer_1 = require("buffer");

var constants_1 = require("./constants"); // Returns generator that encrypts payload from the user


function encryptStream(handshake) {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, chunkBuffer, i, end, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 22;
                break;
              }

              chunk = _step.value;
              chunkBuffer = buffer_1.Buffer.from(chunk.buffer, chunk.byteOffset, chunk.length);
              i = 0;

            case 10:
              if (!(i < chunkBuffer.length)) {
                _context.next = 19;
                break;
              }

              end = i + constants_1.NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG;

              if (end > chunkBuffer.length) {
                end = chunkBuffer.length;
              }

              data = handshake.encrypt(chunkBuffer.slice(i, end), handshake.session);
              _context.next = 16;
              return data;

            case 16:
              i += constants_1.NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG;
              _context.next = 10;
              break;

            case 19:
              _iteratorAbruptCompletion = false;
              _context.next = 4;
              break;

            case 22:
              _context.next = 28;
              break;

            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 28:
              _context.prev = 28;
              _context.prev = 29;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 33;
                break;
              }

              _context.next = 33;
              return _awaitAsyncGenerator(_iterator.return());

            case 33:
              _context.prev = 33;

              if (!_didIteratorError) {
                _context.next = 36;
                break;
              }

              throw _iteratorError;

            case 36:
              return _context.finish(33);

            case 37:
              return _context.finish(28);

            case 38:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 24, 28, 38], [29,, 33, 37]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

exports.encryptStream = encryptStream; // Decrypt received payload to the user

function decryptStream(handshake) {
  return /*#__PURE__*/function () {
    var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
      var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, chunk, chunkBuffer, i, end, _chunk, _yield$_awaitAsyncGen, decrypted, valid;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context2.prev = 2;
              _iterator2 = _asyncIterator(source);

            case 4:
              _context2.next = 6;
              return _awaitAsyncGenerator(_iterator2.next());

            case 6:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
                _context2.next = 29;
                break;
              }

              chunk = _step2.value;
              chunkBuffer = buffer_1.Buffer.from(chunk.buffer, chunk.byteOffset, chunk.length);
              i = 0;

            case 10:
              if (!(i < chunkBuffer.length)) {
                _context2.next = 26;
                break;
              }

              end = i + constants_1.NOISE_MSG_MAX_LENGTH_BYTES;

              if (end > chunkBuffer.length) {
                end = chunkBuffer.length;
              }

              _chunk = chunkBuffer.slice(i, end);
              _context2.next = 16;
              return _awaitAsyncGenerator(handshake.decrypt(_chunk, handshake.session));

            case 16:
              _yield$_awaitAsyncGen = _context2.sent;
              decrypted = _yield$_awaitAsyncGen.plaintext;
              valid = _yield$_awaitAsyncGen.valid;

              if (valid) {
                _context2.next = 21;
                break;
              }

              throw new Error('Failed to validate decrypted chunk');

            case 21:
              _context2.next = 23;
              return decrypted;

            case 23:
              i += constants_1.NOISE_MSG_MAX_LENGTH_BYTES;
              _context2.next = 10;
              break;

            case 26:
              _iteratorAbruptCompletion2 = false;
              _context2.next = 4;
              break;

            case 29:
              _context2.next = 35;
              break;

            case 31:
              _context2.prev = 31;
              _context2.t0 = _context2["catch"](2);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 35:
              _context2.prev = 35;
              _context2.prev = 36;

              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context2.next = 40;
                break;
              }

              _context2.next = 40;
              return _awaitAsyncGenerator(_iterator2.return());

            case 40:
              _context2.prev = 40;

              if (!_didIteratorError2) {
                _context2.next = 43;
                break;
              }

              throw _iteratorError2;

            case 43:
              return _context2.finish(40);

            case 44:
              return _context2.finish(35);

            case 45:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 31, 35, 45], [36,, 40, 44]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

exports.decryptStream = decryptStream;